import { render, staticRenderFns } from "./userManagementComponent.vue?vue&type=template&id=80542138&scoped=true&"
import script from "./userManagementComponent.vue?vue&type=script&lang=js&"
export * from "./userManagementComponent.vue?vue&type=script&lang=js&"
import style0 from "./userManagementComponent.vue?vue&type=style&index=0&id=80542138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80542138",
  null
  
)

export default component.exports